var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesSix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 30.7,
    height: 30.7,
    rx: 4.35,
    stroke: "#565656",
    strokeOpacity: 0.2,
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.815 26C15.7535 26 15.6919 25.9905 15.6326 25.9715C13.6395 25.333 11.9425 24.1084 10.5889 22.3317C9.52325 20.9329 8.66995 19.1919 8.05289 17.1572C7.01196 13.7251 7 10.6677 7 10.5393C7 10.2314 7.23384 9.97385 7.54031 9.94426C7.58646 9.93978 12.229 9.46319 15.4638 7.11407C15.6732 6.96188 15.9568 6.96206 16.1663 7.11413C19.4002 9.46319 24.0433 9.93978 24.0898 9.94432C24.396 9.97421 24.6298 10.2317 24.6298 10.5393C24.6298 10.6677 24.6179 13.7251 23.577 17.1572C22.9599 19.192 22.1066 20.9329 21.0409 22.3317C19.6874 24.1085 17.9905 25.3331 15.9973 25.9715C15.938 25.9905 15.8765 26 15.815 26ZM8.21267 11.0637C8.26234 12.067 8.45548 14.3775 9.20518 16.8375C10.4847 21.0353 12.7081 23.7039 15.8149 24.7724C18.929 23.7015 21.155 21.0239 22.4329 16.8102C23.1775 14.355 23.3685 12.062 23.4175 11.0637C22.0783 10.8683 18.6093 10.207 15.8149 8.32691C13.0202 10.2069 9.55194 10.8683 8.21267 11.0637Z",
    fill: "#494949",
    stroke: "#494949",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4954 19.4109C15.3536 19.4109 15.2156 19.3605 15.1069 19.2675L12.9452 17.4188C12.6943 17.2043 12.6649 16.827 12.8794 16.5761C13.0939 16.3251 13.4712 16.2956 13.7222 16.5102L15.4033 17.9479L18.7354 13.5772C18.9355 13.3147 19.3106 13.264 19.5731 13.4643C19.8357 13.6644 19.8863 14.0395 19.6861 14.302L15.9708 19.1755C15.8711 19.3062 15.7221 19.3902 15.5586 19.4076C15.5375 19.4098 15.5164 19.4109 15.4954 19.4109Z",
    fill: "#494949",
    stroke: "#494949",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesSix);
export default __webpack_public_path__ + "static/media/features-six.dd873acf.svg";
export { ForwardRef as ReactComponent };